module.exports = __webpack_public_path__ + "static/media/warning.c7618366.svg";